
























































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { HdSetting } from '@/types/hd'
import { HdSettingPayload } from '@/api/hd/types'
import { mixins } from 'vue-class-component'
import Form from '@/mixins/form'

interface HTMLAnchorElement {
  download: string
}

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class HdSettingView extends mixins(Form) {
  @Prop(Number) patientId!: number
  @Prop(String) tabStatus!: string
  $store!: ExStore
  setting: HdSettingPayload = {
    dialysisType: 'HD'
  }
  dialysisTypes = [
    'HD',
    'HHD',
    'ECUM',
    'I-HDF',
    'オンラインHDF',
    'オフラインHDF',
    'HF',
    'CHF',
    'CHD',
    'CHDF'
  ]
  startingLabels = [
    {
      label: '目標除水量',
      unit: '設定値(l)',
      prop: 'TargetWaterRemoval'
    },
    {
      label: '除水速度',
      unit: '測定値(l/h)',
      prop: 'TargetUltrafiltrationRate'
    },
    {
      label: '抗凝固剤注入速度',
      unit: '測定値(ml/h)',
      prop: 'AnticoagulantInjectRate'
    }
  ]
  runningLabels = [
    {
      label: '血液流量',
      unit: '設定値(ml/min)',
      prop: 'BloodFlow'
    },
    {
      label: '脈拍',
      unit: '測定値(bpm)',
      prop: 'Pulse'
    },
    {
      label: '収縮期血圧',
      unit: '測定値(mmHg)',
      prop: 'Sbp'
    },
    {
      label: '拡張期血圧',
      unit: '測定値(mmHg)',
      prop: 'Dbp'
    },
    {
      label: '補液速度',
      unit: '測定値(l/h)',
      prop: 'FluidFlowrate'
    }
  ]

  get errors() {
    return this.validator.messages
  }

  get displayTimeHour() {
    const time = this.setting.dialysisTime || 0
    return String(Math.floor(time / 60))
  }

  set displayTimeHour(hour: string) {
    const newHour = parseInt(hour)
    if (isNaN(newHour)) return
    const time = this.setting.dialysisTime || 0
    const minute = time % 60
    const newTime = newHour * 60 + minute
    this.setting = { ...this.setting, dialysisTime: newTime }
  }

  get displayTimeMinute() {
    const time = this.setting.dialysisTime || 0
    return String(time % 60)
  }

  set displayTimeMinute(minute: string) {
    const newMinute = parseInt(minute) || 0
    const time = this.setting.dialysisTime || 0
    const hour = Math.floor(time / 60)
    const newTime = hour * 60 + newMinute
    this.setting = { ...this.setting, dialysisTime: newTime }
  }

  async created() {
    const params: {
      patientId: number
      currentTab?: string
    } = { patientId: this.patientId }
    if (this.tabStatus === 'modal') {
      params['currentTab'] = 'manageOrganization'
    }
    await this.$store.dispatch('hd/fetchLatestHd', params)
    this.setInitialSetting()
  }

  mounted() {
    this.checkError()
  }

  setInitialSetting() {
    const setting = this.$store.getters['hd/setting']
    if (!setting) return
    const keys = ['id', 'registeredDatetime', 'worker', 'patient']
    for (const key of keys) {
      delete setting[key as keyof HdSetting]
    }
    for (const key of Object.keys(setting)) {
      this.$set(this.setting, key, setting[key as keyof HdSetting])
    }
  }

  async save() {
    if (this.validator.hasAnyError()) {
      return
    }
    //TODO: エラー処理
    const payload = Object.entries(this.setting).reduce(
      (obj: { [key: string]: any }, [key, val]) => {
        obj[key] = val === '' ? null : val
        return obj
      },
      {}
    )
    try {
      if (this.tabStatus === 'modal') {
        payload['currentTab'] = 'manageOrganization'
        await this.$api.hd.createSetting({
          patientId: this.patientId,
          payload: payload as HdSettingPayload
        })
        this.$emit('close')
        return
      }
      await this.$api.hd.createSetting({
        patientId: this.patientId,
        payload: payload as HdSettingPayload
      })
      this.$router.replace({ name: 'HdTab' })
    } catch (e) {
      console.error(e)
    }
  }

  checkError() {
    this.validator.hasAnyError()
  }

  closeModal() {
    this.$emit('close')
  }
}
